import Timeline from '../Timeline';

import { Modal, ModalBody, Spinner } from 'reactstrap';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';

import {
    tokenDeleteStages,
    tokenTransferStages,
    tokenContractStages,
    tokenMintStages,
} from '../../constants/tokenActionsStages';

const TokensModal = ({ show, stage, error, action }) => {
    let stagesArray;
    switch (action) {
        case "mint-token":
            stagesArray = tokenMintStages;
            break;
        case 'delete':
            stagesArray = tokenDeleteStages;
            break;
        case 'transfer':
        case "transfer-token":
            stagesArray = tokenTransferStages;
            break;
        case 'transferContract':
            stagesArray = tokenContractStages;
            break;
        default:
            stagesArray = [];
            break;
    }

    const getData = (stages) => {
        const nStage = stages.findIndex(
            (stageItem) => stageItem.name === stage
        );

        return stages.map((stageItem, i) => {
            const newStage = { ...stageItem };

            if (stage === 'confirm') {
                newStage.color = 'success';
            } else {
                if (i < nStage) {
                    newStage.color = 'success';
                }

                if (i > nStage) {
                    newStage.className = 'timeline-item-pending';
                    newStage.color = 'dark';
                }

                if (i === nStage) {
                    if (error) {
                        newStage.color = 'danger';
                        newStage.content = error.message;
                        newStage.meta = null;
                    } else {
                        newStage.meta = <Spinner />;
                        newStage.color = 'warning';
                    }
                }
            }

            return newStage;
        });
    };

    const getHeader = (action) => {
        switch(action) {
            case "delete":
                return "Delete token";
            case "transfer":
                return "Transfer token";
            case "transfer-token":
                return "Transfer tokens";
            case "mint-token":
                return "Mint tokens";
            default:
                return "Transfer contract";
        }
    } 

    return (
        <Dialog open={show} disableEscapeKeyDown fullWidth maxWidth="md">
            <ModalBody className="px-sm-4 mx-50 py-4">
                <DialogTitle>
                    {getHeader(action)}
                </DialogTitle>

                <Timeline
                    className="ms-50 mb-0 mt-4"
                    data={getData(stagesArray)}
                />
            </ModalBody>
        </Dialog>
    );
};

export default TokensModal;

{
    /* <Modal isOpen={show} className="modal-dialog-centered modal-lg">
    <ModalBody className="px-sm-4 mx-50 py-4">
        <h4 className="modal-title">
            {action === 'delete'
                ? 'Delete token'
                : action === 'transfer'
                ? 'Tranffer token'
                : 'Tranffer contract'}
        </h4>
        <Timeline
            className="ms-50 mb-0 mt-4"
            data={getData(stagesArray)}
        />
    </ModalBody>
</Modal> */
}
